import * as React from 'react'
import { FiEdit2 } from 'react-icons/fi'

export default function() {
  return (
    <FiEdit2
      style={{ marginRight: '5px', minHeight: '16px', minWidth: '16px' }}
    />
  )
}
